import api from './api';

export interface Cities {
    id: string;
    name: string;
    province_id: string;
    // Add other Cities properties as needed
}

export const CitiesService = {
    // Fetch all Citiess
    async fetchCities(): Promise<Cities[]> {
        const response = await api.get<Cities[]>('/Cities');
        return response.data;
    }
}